export default function NotificationItem() {
  return (
    <svg
      width='15'
      height='21'
      viewBox='0 0 15 21'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M8.75 5.8125V0.5H0.9375C0.677083 0.5 0.455729 0.591146 0.273438 0.773438C0.0911458 0.955729 0 1.17708 0 1.4375V19.5625C0 19.8229 0.0911458 20.0443 0.273438 20.2266C0.455729 20.4089 0.677083 20.5 0.9375 20.5H14.0625C14.3229 20.5 14.5443 20.4089 14.7266 20.2266C14.9089 20.0443 15 19.8229 15 19.5625V6.75H9.6875C9.42708 6.75 9.20573 6.65885 9.02344 6.47656C8.84115 6.29427 8.75 6.07292 8.75 5.8125ZM15 5.26562V5.5H10V0.5H10.2344C10.4948 0.5 10.7161 0.591146 10.8984 0.773438L14.7266 4.60156C14.9089 4.78385 15 5.00521 15 5.26562Z'
        fill='#33820D'
      />
    </svg>
  );
}
